import loadable from '@loadable/component';

import type { IIcons } from '../models';

// contentType для docx
const docxContentType = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
const msxlsContentType = 'vnd.ms-excel';
const msxlsxContentType = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const EXTENSIONS = [
    'vnd.openxmlformats-officedocument.wordprocessingml.document',
    'vnd.ms-excel',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'doc',
    'xls',
    'msword',
    '1c',
    'csv',
    'pdf',
    'png',
    'ppt',
    'sketch',
    'svg',
    'txt',
    'xml',
    'rar',
    'zip',
    'rtf',
    'exe',
    'unknown',
] as const;

const doc = loadable(() => import(/* webpackChunkName: "IconDoc" */ './doc'), {
    resolveComponent: mod => mod.Doc,
});

const xls = loadable(() => import(/* webpackChunkName: "IconXls" */ './xls'), {
    resolveComponent: mod => mod.Xls,
});

const MSDOC_ICONS = {
    doc,
    msword: doc,
    xls,
    docx: doc,
    xlsx: xls,
    [docxContentType]: doc,
    [msxlsContentType]: xls,
    [msxlsxContentType]: xls,
};

export const ICONS: IIcons = {
    '1c': loadable(() => import(/* webpackChunkName: "IconOnec" */ './onec'), {
        resolveComponent: mod => mod.OneC,
    }),
    csv: loadable(() => import(/* webpackChunkName: "IconCsv" */ './csv'), {
        resolveComponent: mod => mod.Csv,
    }),
    pdf: loadable(() => import(/* webpackChunkName: "IconPdf" */ './pdf'), {
        resolveComponent: mod => mod.Pdf,
    }),
    png: loadable(() => import(/* webpackChunkName: "IconPng" */ './png'), {
        resolveComponent: mod => mod.Png,
    }),
    ppt: loadable(() => import(/* webpackChunkName: "IconPpt" */ './ppt'), {
        resolveComponent: mod => mod.Ppt,
    }),
    sketch: loadable(() => import(/* webpackChunkName: "IconSketch" */ './sketch'), {
        resolveComponent: mod => mod.Sketch,
    }),
    svg: loadable(() => import(/* webpackChunkName: "IconSvg" */ './svg'), {
        resolveComponent: mod => mod.Svg,
    }),
    txt: loadable(() => import(/* webpackChunkName: "IconTxt" */ './txt'), {
        resolveComponent: mod => mod.Txt,
    }),
    xml: loadable(() => import(/* webpackChunkName: "IconXml" */ './xml'), {
        resolveComponent: mod => mod.Xml,
    }),
    rar: loadable(() => import(/* webpackChunkName: "IconRar" */ './rar'), {
        resolveComponent: mod => mod.Rar,
    }),
    zip: loadable(() => import(/* webpackChunkName: "IconZip" */ './zip'), {
        resolveComponent: mod => mod.Zip,
    }),
    rtf: loadable(() => import(/* webpackChunkName: "IconRft" */ './rtf'), {
        resolveComponent: mod => mod.Rtf,
    }),
    exe: loadable(() => import(/* webpackChunkName: "IconExe" */ './exe'), {
        resolveComponent: mod => mod.Exe,
    }),
    unknown: loadable(() => import(/* webpackChunkName: "IconUnknown" */ './unknown'), {
        resolveComponent: mod => mod.Unknown,
    }),
    ...MSDOC_ICONS,
};
